export const PersonInfoCardMobile = () => {
  return <div>PersonInfoCardMobile</div>;
};
